import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {type IAsset} from '../schema';

export const canUnlockAsset = (asset?: IAsset) => {
	return (
		asset != null &&
		asset.readOnly === 1 &&
		currentUserMeetsUserLevel(UserLevel.ADMIN)
	);
};
